<template>
  <el-dialog
    v-if="showLocal"
    id="inviteLeaderModal"
    :visible.sync="showLocal"
    :width="dialogWidth"
    center
    @close="discard"
    @opened="loadEngagements"
  >
    <el-tabs
      v-model="activeName"
      stretch
    >
      <el-tab-pane
        label="Invite Leaders"
        name="invite"
      >
        <div class="cardHeader">
          <div>
            {{ $t('coach.leader.invitation.inviteLeaders') }}
          </div>
          <div
            :style="remainInvitation <= 0 ? 'color: red;' : null"
          >
            {{ $t('coach.leader.invitation.availableLeaders') }}:
            <span>
              {{ displayAvailable }}
            </span>
          </div>
        </div>
        <div>
          <div class="title">
            {{ $t('coach.leader.invitation.leaderEmail') }}:
          </div>
          <div class="description">
            {{ $t('coach.leader.invitation.addLeaderCsv') }}
          </div>
          <el-form
            v-for="(invite, key) in inviteList"
            ref="leaderForm"
            :key="`invite${key}`"
            :model="invite"
            :rules="rules"
          >
            <el-row :gutter="5">
              <el-col :span="14">
                <div class="subTitle">
                  {{ $t('common.email') }}
                </div>
                <el-form-item
                  prop="email"
                  :error="invite.error"
                >
                  <el-input
                    v-model="invite.email"
                    :placeholder="$t('account.emailAddress')"
                    @change="invite.error = null"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <div class="subTitle">
                  {{ $t('common.duration') }}
                </div>
                <div style="display: flex; flex-wrap: nowrap; align-items: center;">
                  <el-form-item prop="duration">
                    <el-select
                      v-model="invite.duration"
                      :value="10"
                    >
                      <el-option
                        :label="`4 ${$t('coach.leader.invitation.durationSessions')}`"
                        :value="4"
                      />
                      <el-option
                        :label="`7 ${$t('coach.leader.invitation.durationSessions')}`"
                        :value="7"
                      />
                      <el-option
                        :label="`10 ${$t('coach.leader.invitation.durationSessions')}`"
                        :value="10"
                      />
                      <el-option
                        :label="`13 ${$t('coach.leader.invitation.durationSessions')}`"
                        :value="13"
                      />
                    </el-select>
                  </el-form-item>
                  <el-button
                    type="default"
                    size="mini"
                    style="
                      background: transparent;
                      border: none;
                      display: flex;
                      width: 24px;
                      height: 24px;
                      padding: 0;
                      margin: 5px;
                      justify-content: center;
                      align-items: center;"
                    @click="deleteLeaderSlot(key)"
                  >
                    <i class="error el-icon-close"></i>
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <el-button
            type="text"
            style="padding: 5px 4px;"
            @click="addLeaderSlot"
          >
            + {{ $t('coach.leader.invitation.addEmail') }}
          </el-button>
        </div>

        <div class="emailSampleWrap">
          <div class="engagementTitle">
            {{ $t('coach.leader.invitation.emailSample') }}
          </div>
          <div class="description">
            {{ $t('coach.leader.invitation.sampleDesc') }}
          </div>
          <div class="emailSample">
            <i18n path="coach.leader.invitation.sampleContent">
              <template #accessAccount>
                {{ $t('coach.leader.invitation.accessAccount') }}
              </template>
              <template #email>
                <span style="text-decoration: underline;">
                  Support@GlobalCoachGroup.com
                </span>
              </template>
              <template #gcg>
                Global Coach Group
              </template>
            </i18n>
          </div>
        </div>
        <div class="dialog-footer">
          <el-button
            round
            @click="discard"
          >
            {{ $t('common.discard') }}
          </el-button>
          <el-button
            type="primary"
            round
            @click="addUsers"
          >
            {{ $t('common.add') }}
          </el-button>
        </div>
      </el-tab-pane>

      <el-tab-pane
        label="Manage Leaders"
        name="manage"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="description"
          v-html="$t('customAlert.subscription.availEngagementDescription2')"
        ></div>
        <!-- eslint-enable vue/no-v-html -->

        <div
          class="engagementTitle"
          :class="{redText: selectedLeader.length > maxInviteCt}"
        >
          <i18n path="customAlert.subscription.selectedLeaderCount">
            <template #selectedLeader>
              {{ selectedLeader.length }}
            </template>
          </i18n>
          /
          <i18n path="customAlert.subscription.availEngagementCount">
            <template #availEngagements>
              {{ maxInviteCt }}
            </template>
          </i18n>
        </div>

        <el-table
          ref="multipleTable"
          v-loading="process.engagement"
          :data="engagements"
          @selection-change="handleSelectionChange"
        >
          <!--<el-table-column
            type="selection"
            width="55"
          >-->
          <el-table-column
            width="55"
          >
            <template slot-scope="data">
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('customAlert.subscription.deactivateDisabled')"
                placement="top"
                :disabled="data.row.status !== 'completed'"
              >
                <div>
                  <el-checkbox
                    :key="data.row.uuid"
                    :value="selectedLeader.includes(data.row.uuid)"
                    :disabled="data.row.status === 'completed'"
                    @change="handleSelectionChange(data.row.uuid, $event)"
                  />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            property="full_name"
            label="Name"
            width="240"
          />
          <el-table-column
            property="email"
            label="Email"
          />
        </el-table>

        <div class="dialog-footer">
          <el-button
            type="primary"
            round
            @click="updateEngagements"
          >
            {{ $t('common.confirm') }}
          </el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import api from '@/api';
import dialog from '@/mixins/dialog';
import emailValidator from '@/mixins/emailValidator';

export default {
  mixins: [
    dialog,
    emailValidator,
  ],

  props: {
    invitationStatus: {
      type: String,
      default: '-',
    },
  },

  data() {
    // const that = this;
    return {
      process: {
        engagement: false,
      },
      inviteList: [
        {
          role_type: 'leader', email: '', duration: 10, error: null,
        },
      ],
      rules: {
        email: [
          { required: true, message: this.$t('common.rule.email.required'), trigger: 'blur' },
          {
            type: 'email',
            message: this.$t('common.rule.email.correct'),
            trigger: ['blur', 'change'],
          },
        ],
      },
      selectedLeader: [],
      engagements: [],
      activeName: 'invite',
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      maxInviteCt: (state) => state.user.profile.max_invite_ct,
      currInviteCt: (state) => state.user.profile.curr_invite_ct,
    }),

    remainInvitation() {
      let count = 0;

      if (this.invitationStatus && this.invitationStatus !== '-') {
        const split = this.invitationStatus.split('/');
        count = split[1] - split[0];
      }

      return (count < 0) ? 0 : count;
    },

    displayAvailable() {
      let display = '-';

      if (this.invitationStatus && this.invitationStatus !== '-') {
        const split = this.invitationStatus.split('/');
        display = `${this.remainInvitation}/${split[1]}`;
      }

      return display;
    },
  },

  watch: {
    showLocal(newValue) {
      if (newValue && this.remainInvitation <= 0) {
        this.activeName = 'manage';
      }
    },
  },

  mounted() {
    if (this.$route.query.manageEngagement) {
      this.activeName = 'manage';
    }
  },

  methods: {
    ...mapActions('coachAlerts', [
      'fetchCoachAlerts',
    ]),

    addLeaderSlot() {
      if (this.inviteList.length < this.remainInvitation) {
        this.inviteList.push({
          role_type: 'leader', email: '', duration: 10, error: null,
        });
      } else {
        this.$message.error(this.$t('coach.leader.invitation.canNotAddMore'));
      }
    },

    handleSelectionChange(val, option) {
      if (Array.isArray(val)) {
        this.selectedLeader = val.map((el) => el.uuid);
      } else if (option) {
        this.selectedLeader.push(val);
      } else {
        this.selectedLeader = this.selectedLeader.filter((el) => el !== val);
      }
    },

    async confirmLeader() {
      console.log(this.selectedLeader);
      // this.showLocal = false;

      // try {
      //   // if (this.currInviteCt > this.maxInviteCt) {
      //   // Change 'engagement_status' depending of condition

      //   const data = {
      //     leader_uuid_list: this.selectedLeader,
      //     engagement_status: 'exception',
      //   };
      //   await api.bulkUpdateLeaderEngagement(data);
      //   this.showLocal = false;
      // } catch (err) {
      //   console.log(err);
      // }
    },

    deleteLeaderSlot(key) {
      if (this.inviteList.length > 1) {
        this.inviteList.splice(key, 1);
        this.inviteList = this.inviteList.map((el) => {
          const result = el;
          result.error = null;
          return result;
        });
      }
    },

    async addUsers() {
      let flag = true;
      if (this.$refs.leaderForm && this.$refs.leaderForm.length) {
        this.$refs.leaderForm.forEach((el) => {
          el.validate(async (valid) => { if (!valid) { flag = false; } });
        });
      }

      if (flag) {
        this.$confirm(this.$t('coach.leader.invitation.areYouSure'), '', {
          confirmButtonText: this.$t('common.ok'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning',
        }).then(async () => {
          try {
            const sendData = this.inviteList.map((el) => {
              const result = {
                role_type: el.role_type,
                email: el.email,
                duration: el.duration,
              };
              return result;
            });
            const response = await api.inviteLeader(sendData);
            this.$emit('newUsers', response.data);
            this.$message.success(this.$t('coach.leader.invitation.invitationSent'));
            this.discard();
          } catch (err) {
            if (err.field) {
              this.formatAPIError(err.field);

              // Special case of this API for error structured like:
              // {"field":[{},{"email":["Enter a valid email address."]}]}
              // Display an error alert of the first message
              if (Array.isArray(err.field)) {
                const [errObj] = err.field.filter(
                  (el) => Object.entries(el).length > 0,
                );
                if (errObj) {
                  const key = Object.keys(errObj)[0];
                  this.$message.error(errObj[key][0]);
                }
              }
            } else if (err.msg) {
              this.$message.error(err.msg);
            }
          }
        }).catch((err) => {
          // Avoid Uncaught error
          console.log(err);
        });
      }
    },

    formatAPIError(data) {
      if (Array.isArray(data)) {
        data.forEach((el, index) => {
          Object.keys(el).forEach((key) => {
            if (el[key].length === 1) {
              this.inviteList[index].error = `${el[key]}`;
            } else if (el[key].length > 1) {
              // this.inviteList[index].error = `${this.inviteList[index].email}\n`;
              el[key].forEach((err) => {
                this.inviteList[index].error += `${err}`;
              });
            }
          });
        });
      } else if (typeof data === 'object') {
        Object.keys(data).forEach((key) => {
          if (data[key].length === 1) {
            this.inviteList[0].error = data[key];
          } else if (data[key].length > 1) {
            this.inviteList[0].error = `${this.inviteList[0].email}\n`;
            data[key].forEach((err) => {
              this.inviteList[0].error += `- ${err}\n`;
            });
          }
        });
      }
    },

    discard() {
      this.inviteList = [{
        role_type: 'leader', email: '', duration: 10, error: null,
      }];
      if (this.$refs.leaderForm && this.$refs.leaderForm.length) {
        this.$refs.leaderForm.forEach((el) => {
          el.resetFields();
        });
      }
      this.showLocal = false;
    },

    async loadEngagements() {
      try {
        this.process.engagement = true;
        const response = await api.getBulkLeaderEngagement();
        this.engagements = response.data;

        // Since elementUI doesn't allow v-model for multiple selection table,
        // we need to have this retard code
        const selected = this.engagements.filter((el) => el.status === 'on_going' || el.status === 'completed');

        setTimeout(() => {
          selected.forEach((el) => {
            this.$refs.multipleTable.toggleRowSelection(el);
          });
        }, 100);

        this.selectedLeader = selected.map((el) => el.uuid);
      } catch (error) {
        console.log(error);
      } finally {
        this.process.engagement = false;
      }
    },

    async updateEngagements() {
      if (this.selectedLeader.length > this.maxInviteCt) {
        this.$alert(
          `You cannot have more than ${this.maxInviteCt} engagement(s)`,
          'Unable to save', {
            confirmButtonText: 'OK',
            type: 'warning',
          },
        );
      } else {
        try {
        // 2 requests: 1 to handle exception, 1 to handle on_going
        // put all leader to exceptions, then set on-Going the selected ones
          const exceptionLeader = this.engagements.map((el) => el.uuid);
          let data = {
            leader_uuid_list: exceptionLeader,
            engagement_status: 'exception',
          };
          await api.bulkUpdateLeaderEngagement(data);

          data = {
            leader_uuid_list: this.selectedLeader,
            engagement_status: 'on_going',
          };
          await api.bulkUpdateLeaderEngagement(data);

          this.fetchCoachAlerts();
          this.$emit('userUpdated');
          this.showLocal = false;
          this.$message({
            message: this.$t('coach.leader.invitation.engagementSettingsSaved'),
            type: 'success',
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>

<style lang="scss">
#inviteLeaderModal {
  .redText {
    color: red;
  }

  .cardHeader {
    display: flex;
    font-size: 17px;
    font-weight: bold;
    justify-content: space-between;
    padding: 5px 0 18px;
  }

  .el-dialog {
    min-width: 320px;

    .el-dialog__header {
      text-align: left;
    }

    .el-dialog__body {
      padding: 0 25px 10px 25px;

      .title {
        font-weight: bold;
      }

      .engagementTitle {
        font-weight: bold;
        text-align: right;
        margin-bottom: 15px;
      }

      .el-table thead {
        color: black;
      }

      .subTitle {
        font-weight: bold;
        font-size: 12px;
      }

      .description {
        word-break: break-word;
        margin: 8px 0;
      }

      .el-form {
        .el-form-item {
          margin-bottom: 5px;
        }

        .el-form-item__content {
          line-height: 25px;

          input,
          textarea {
            border-radius: 10px;
          }

          .el-form-item__error {
            white-space: pre-line;
            padding-top: 0;
            line-height: 16px;
            position: relative;
            top: -10px;
          }
        }
      }

      .emailSampleWrap {
        .title {
          font-weight: bold;
        }

        .description {
          padding: 10px 0;
          word-break: break-word;
        }

        .emailSample {
          padding: 5px 15px;
          border: 1px #e2e2e2 solid;
          border-radius: 10px;
          word-break: break-word;
          white-space: pre-line;
          line-height: 27px;
        }
      }

      .dialog-footer {
        text-align: center !important;
        margin-top: 20px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
